import { NavigationGuard } from 'vue-router';

import { getViewer } from '@/composables/useViewer';
import { getConnections } from '@/composables/useConnections';
import { isDefined } from '@/util';

const authGuard: NavigationGuard = async (to, __, next) => {
  const viewer = await getViewer();

  if (to.meta?.authenticated === false && viewer === null) {
    return next();
  }

  if (viewer === null) {
    return next({ name: 'login', query: { next: to.fullPath } });
  }

  const routesWithoutSalesforceConnections = new Set([
    'change-password',
    'subscription',
    'subscription.success',
    'subscription.failure',
  ]);

  if (isDefined(to.name) && routesWithoutSalesforceConnections.has(to.name)) {
    return next();
  }

  const { source, target } = await getConnections();

  if (to.name === 'connect' && (source === null || target === null)) {
    return next();
  }

  if (source !== null && target !== null) {
    if (to.name === 'connect') {
      return next('/');
    }
    return next();
  }

  return next({ name: 'connect' });
};

export default authGuard;
